export default "__VITE_ASSET__DjEInWwZ__"